module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mdigurp1-374a529589c3ca806e5a204b6420145e.jpg";